interface TravelStatusPayload {
    eventType: 'approved' | 'rejected';
    travelId: string;
    title: string;
    userName: string;
    userEmail: string;
    commentByRrhh?: string;
    approverEmail?: string;
}

export const sendTravelStatusToN8n = async (
    eventType: 'approved' | 'rejected',
    travelId: string,
    title: string,
    userName: string,
    userEmail: string,
    commentByRrhh?: string,
    approverEmail?: string
): Promise<{ success: boolean; error?: string }> => {
    const N8N_WEBHOOK_URL = import.meta.env.VITE_N8N_WEBHOOK_TRAVEL_STATUS_URL;

    if (!N8N_WEBHOOK_URL) {
        return { success: false, error: 'Webhook URL no configurada' };
    }

    try {
        const payload: TravelStatusPayload = {
            eventType,
            travelId,
            title,
            userName,
            userEmail,
            commentByRrhh,
            approverEmail,
        };

        const response = await fetch(N8N_WEBHOOK_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        if (!response.ok) return { success: false, error: `HTTP ${response.status}` };
        return { success: true };
    } catch (error) {
        return { success: false, error: error instanceof Error ? error.message : 'Error desconocido' };
    }
};